import React from 'react';
import LineColumnArea from './LineColumnArea';

import { Row, Card, CardBody, Col } from "reactstrap";

// Static data can be defined directly in the component or imported from another file
const MonthlySalesReport = () => {

    // Static data for demo purposes
    const staticData = {
        revenue: {
            options: {
                chart: {
                    stacked: false,
                    toolbar: {
                        show: false,
                    },
                },
                stroke: {
                    width: [0, 0.5, 1],
                    curve: "smooth",
                    dashArray: [0, 8, 5]
                },
                plotOptions: {
                    bar: {
                        columnWidth: "18%",
                    },
                },
                colors: ["#0ab39c", "rgba(212, 218, 221, 0.18)", "rgb(251, 77, 83)"],
                fill: {
                    opacity: [0.85, 0.25, 1],
                    gradient: {
                        inverseColors: false,
                        shade: "light",
                        type: "vertical",
                        opacityFrom: 0.85,
                        opacityTo: 0.55,
                        stops: [0, 100, 100, 100],
                    },
                },
                labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
                markers: {
                    size: 0,
                },
                legend: {
                    offsetY: 11,
                },
                xaxis: {
                    title: {
                        text: "Months"
                    },
                    type: "month",
                },
                yaxis: {
                    title: {
                        text: "Revenue",
                    },
                },
                tooltip: {
                    shared: true,
                    intersect: false,
                    y: {
                        formatter: function (y) {
                            if (typeof y !== "undefined") {
                                return y.toFixed(0) + "points"
                            }
                            return y
                        },
                    },
                },
                grid: {
                    borderColor: "#f1f1f1",
                },
            },
            series: [
                {
                    name: "Revenue",
                    type: "column",
                    data: [23, 11, 22, 27, 13, 22, 37, 21, 44, 22, 30, 18],
                },
            ]
        }
    };

    return (
        <React.Fragment>
            <Col xl={8}>
                <Card>
                    <CardBody>
                        <div className="d-flex align-items-center">
                            <div className="flex-grow-1">
                                <h5 className="card-title">Monthly Sales Report</h5>
                            </div>
                        </div>
                        <div>
                            {/* Pass the static data as a prop */}
                            <LineColumnArea salesReportData={staticData.revenue} />
                        </div>
                    </CardBody>
                    <CardBody className="border-top">
                        <div className="text-muted text-center">
                            <Row>
                            </Row>
                        </div>
                    </CardBody>
                </Card>
            </Col>
        </React.Fragment>
    );
};

export default MonthlySalesReport;
